module.exports = "\r\n<div class=\"container text-center\" style=\"padding: 130px;\">\r\n\r\n    <h1>ERROR 404: La página no fue encontrada...</h1>\r\n\r\n    <hr>\r\n\r\n    <img src=\"https://s3.amazonaws.com/images.seroundtable.com/t-google-404-1299071983.jpg\" alt=\"error\" class=\"center\">\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/componentes/not-found/not-found.component.html
// module id = ./src/app/componentes/not-found/not-found.component.html
// module chunks = main